





















































































import ResourceItemCard from "./ResourceItemCard.vue";
import { RevisionItem } from "@megarax/client/src/resources/RevisionItem";
import ResourceItemView, { resourceItemManager } from "./ResourceItemView.vue";
import DecisionForm from "@/apps/management/decision/DecisionForm.vue";
import {
  Decision,
  decisionResource,
} from "@megarax/client/src/resources/Decision";
import { useActions } from "@/shared/useMegaraxClient";
import { createComponent, computed, Ref, ref } from "@vue/composition-api";
import { Resource } from "@megarax/client/src";
import RevisionDuplicateButton from "./RevisionDuplicateButton";
import ResourceItemReference from "./ResourceItemReference";
import DraftsList from "./DraftsList.vue";
import { formValidator } from "@/shared/formValidator";
import SpinnerCard from "@/components/SpinnerCard.vue";
import { RevisionActions } from "@megarax/client/src/revision";
import { getModulePath } from "@/apps/getPath";
import { ResourceAppModule } from "@/shared/app";
import { decisionModule } from "../../apps/management/decision/module";

interface Props {
  module: ResourceAppModule<RevisionActions>;
}

export default createComponent<Props>({
  name: "RevisionItemView",
  components: {
    DecisionForm,
    ResourceItemCard,
    RevisionDuplicateButton,
    ResourceItemReference,
    DraftsList,
    SpinnerCard,
  },
  props: {
    module: {
      required: true,
    },
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if ((this as any).editing) {
      if (!window.confirm("Wyjść bez zapisywania?")) {
        return;
      }
    }
    next();
  },
  setup(props, ctx) {
    const editing = ref(false);

    const {
      item,
      fetchItem,
      save,
      deleteItem,
      canEdit,
    } = resourceItemManager<RevisionItem>(props.module.resource, ctx);

    const newStartingDecision: Ref<Decision | null> = ref(null);

    function getDecisionTitle() {
      const operationName = item.value!.target ? "EDYCJA" : "NOWE";

      return `(${operationName}) ${item.value!.name}`;
    }

    function createNewStartingDecision() {
      newStartingDecision.value = new Decision();
      newStartingDecision.value.title = getDecisionTitle();
    }

    function deleteStartingDecision() {
      newStartingDecision.value = null;
    }

    const { form: decisionForm, validate: validateDecision } = formValidator();

    const actions = useActions(props.module.resource);

    async function onNewDecisionResponse(response: Decision) {
      ctx.root.$router.push(getModulePath(decisionModule, response.id!));
    }

    fetchItem(ctx.root.$route.params.id);

    function saveEdit(item: RevisionItem) {
      save(item).then(() => {
        editing.value = false;
      });
    }

    return {
      actions,
      createNewStartingDecision,
      decisionForm,
      deleteItem,
      deleteStartingDecision,
      editing,
      item,
      newStartingDecision,
      onNewDecisionResponse,
      saveEdit,
      validateDecision,
      canEdit,
    };
  },
});
